import React, { useState, useEffect } from "react";
import { MultiSelect } from 'primereact/multiselect';
import { setProductAtt } from 'src/redux/actions';
import { useDispatch, useSelector } from 'react-redux';

export default function ProductAttribute(props) {
  const [selectAll, setSelectAll] = useState(true);
  const dispatch = useDispatch();
  const product_att = useSelector((state) => state.filter.product_att) || [];
  const items = Array.from(Object.keys(props.remote_source), key => ({
    label: props.remote_source[key],
    value: key,
  }));
  return (
    <div className="card flex justify-content-center" style={{border:'none'}}>
            <label className="control-label justify-content-start" htmlFor={props.id}>
            {props.label} 
          </label>
      <MultiSelect
        value={product_att}
        options={items}
        onChange={(e) => dispatch(setProductAtt(e.value))}

        filter
        maxSelectedLabels={1}
        placeholder={"Select " + props.label}
        className="w-full md:w-20rem"
      />
    </div>
  );
}
